const hotList = () => import('@/pages/community/hot/index.vue');

export default [{
    path: '/community/hot',
    component: hotList,
    meta: [{
        name: '社区管理'
    },
    {
        name: '热词列表',
        activeRoute: '/community/hot'
    }]
}];